<template>
  <v-container fluid class="d-flex align-center justify-center">
    <v-layout class="d-flex align-center justify-center">
    <div class="wid-100">
        <v-row dense >
          <v-col cols="12">

            <div class="f-r pl-1">
              <v-btn
                small
                color="green lighten-2"
                class="white--text"
                @click="addBtnClicked"
              >추가</v-btn>
            </div>
            <div class="f-r">
              <v-btn
                small
                color="red lighten-2"
                class="white--text"
                @click="deleteBtnClicked"
              >선택 삭제</v-btn>
            </div>
          </v-col>
          <v-col cols="12" >
            <div >
              <v-data-table
                :headers="headers"
                :items="gridList"
                class="elevation-1 dTable-1"
                :items-per-page="20"
                hide-default-footer
                disable-pagination>
                <template v-slot:[`item.select_yn`]="{ item }">
                  <v-checkbox
                    v-model="item.select_yn"
                    class="pa-0 ma-0"
                    hide-details
                    dense
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.comp_nm`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.comp_nm"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.dept_nm`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.dept_nm"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.pstn_nm`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.pstn_nm"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.work_term`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.work_term"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.chrg_task`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.chrg_task"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
                <template v-slot:[`item.upd_dtm`]="{ item }">
                  <v-text-field
                    class="pa-0 ma-0"
                    v-model="item.upd_dtm"
                    hide-details
                    outlined
                    dense
                    @change="gridItemChanged(item)"
                  ></v-text-field>
							  </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ["propParams"],
  data(){
    return {
      headers:[
        { text: '선택', value:'select_yn', width:"5%"},
        { text: '회사명', value:'comp_nm', width:"15%"},
        { text: '부서', value:'dept_nm', width:"15%"},
        { text: '직위', value:'pstn_nm', width:"15%"},
        { text: '근무기간', value:'work_term', width:"15%"},
        { text: '담당업무', value:'chrg_task', width:"15%"},
        // { text: '수정일자', value:'upd_dtm', width:"15%"},
      ],
      gridList: [],
      changedList: [],    // 추가, 수정된 목록
      mberSno: "",
      loginMberSno: "",
    }
  },
  created() {
    this.mberSno = this.propParams.mberSno;
    this.loginMberSno = this.$session.get("mberSno");

    this.getMberCrrList();
  },
  methods: {
    // 경력 수정됨
    gridItemChanged(item) {
      this.itemChanged();
      // console.log("gridItemChanged : item.crr_sno : " + item.crr_sno);
      // 추가된 목록인 경우 -> [추가] 시 changedList에도 추가함
      if(item.crr_sno == null || item.crr_sno == "") {
        return;
      }

      let found = false;
      this.changedList.forEach((e) => {
        if(e.crr_sno == item.crr_sno) {
          found = true;
        }
      });

      if(!found) {
        this.changedList.push(item);
      }
    },
    getMberCrrList() {
			const params = new FormData();
      params.append("mber_sno", this.mberSno);

			this.$http.post("/admin/getMberCrrList", params).then((res) => {
        // console.log("gridList: " + this.gridList);
        this.gridList = res.data.result;

        this.gridList.forEach((e) => {
          e.select_yn = false;
          e.new_yn = false;
        });

        this.changedList = [];
			}).catch(function (error) {
					console.log(error);
				}
			);
    },
    deleteBtnClicked() {
      console.log("deleteCrr");

      // 선택 체크된 목록 확인 -> deleteList 에 추가
      let deleteList = [];
      let isSelected = false;

      // for(let i = 0; i < this.gridList.length; i++) {
      //   if(this.gridList[i].select_yn) {
      //     isSelected = true;

      //     if(!this.gridList[i].new_yn) {
      //       deleteList.push(this.gridList[i]);
      //     }
      //   }
      // }
      deleteList = this.gridList.filter((e) => {
        if(e.select_yn) isSelected = true;
        return e.select_yn && !e.new_yn;
      });

      // 데이터 검증
      // deleteList.forEach((e) => {
      //   console.log("deleteList: crr_sno[" + e.crr_sno + "]");
      // });

      // 선택된 항목이 없는 경우
      if(!isSelected) {
        alert("선택된 목록이 없습니다.");
        return;
      }

      if(confirm("삭제 후 목록을 다시 조회합니다.\n삭제하시겠습니까?")) {
        if(deleteList.length > 0) {
          let params = new URLSearchParams();
          params.append("deleteList", JSON.stringify(deleteList));

          this.$http.post("/admin/deleteMberCrrList", params).then((res) => {
            console.log(res.data);
            // this.getMberCrrList();
            this.gridList = this.gridList.filter((e) => {
              return !(e.select_yn);
            });

            this.changedList = this.changedList.filter((e) => {
              return !(e.select_yn);
            });
          })
          .catch(function (error) {
              console.log(error);
            }
          );
        } 
        // 추가된 객체만 선택된 경우
        else {
          // this.getMberCrrList();
          this.gridList = this.gridList.filter((e) => {
            return !(e.select_yn);
          });

          this.changedList = this.changedList.filter((e) => {
            return !(e.select_yn);
          });
        }
      }
    },
    addBtnClicked() {
      let maxOdr = 0;

      this.gridList.forEach((e) => {
        if(e.odr > maxOdr) {
          maxOdr = e.odr;
        }
      });

      maxOdr++;

      this.gridList.push({new_yn:true, select_yn:false, crr_sno:"", mber_sno:this.mberSno, odr:maxOdr, comp_nm:"", dept_nm:"", pstn_nm:"", work_term:"", chrg_task:""});
      this.changedList.push(this.gridList[this.gridList.length - 1]);
      // 객체 복사가 필요하면 아래의 방법으로 해야 함
      //this.changedList.push({...this.gridList[this.gridList.length - 1]}); 
      // 객체 안에 또 객체가 있을 경우 아래의 방법으로 해야 함
      // JSON.parse(JSON.stringify(item))

      // 데이터 검증
      // this.changedList.forEach((e) => {
      //   console.log("changedList: crr_sno[" + e.crr_sno + "]");
      // });
    },
    saveBtnClicked() {
      console.log("saveCrr");

      if(this.changedList.length == 0) {
        // alert("수정된 내용이 없습니다.");
        return;
      }

      // true/false -> 'Y'/'N' 변환
      this.changedList.forEach((e) => {
        e.new_yn = e.new_yn == true ? 'Y' : 'N';
      });

      // if(confirm("저장하시겠습니까?")) {
        let params = new URLSearchParams();

        params.append("login_mber_sno", this.loginMberSno);
        params.append("changedList", JSON.stringify(this.changedList));

        this.$http.post("/admin/upsertMberCrrList", params).then((res) => {
          console.log(res.data);
          // alert("저장되었습니다.");
          this.getMberCrrList();
        }).catch(function (error) {
            console.log(error);
        });
      // }
    },
    itemChanged() {
      this.$emit('tabChanged', "careerTab");
    }
  }
}
</script>

<style>

</style>